export const StorageKeys = {
  token: "ReactToken",
};
